import React from 'react';
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';
import { Row, Col, Typography } from 'antd';

const JobDetailDescription = ({ description }) => {
  return (
    <>
      {
        description && description !== ''
          ? (
            <Row style={{ marginTop: '80px' }}>
              <Col>
                <Typography.Text className="job-detail-desc-title">About the role</Typography.Text>
              </Col>
              <Col style={{ width: '100%', maxWidth: '800px', marginTop: '24px' }}>
                <Typography.Text className="job-detail-desc-desc"><span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(description) }}/></Typography.Text>
              </Col>
            </Row>
          )
          : null
      }
    </>
  );
};

JobDetailDescription.propTypes = {
  description: PropTypes.string
};

export default JobDetailDescription;
